import api from '@/core/api/client';

export interface StaffAccessLog {
  id: string;
  action: string;
  entityType: string;
  entityId?: string;
  metadata?: {
    impersonating?: boolean;
    staffRole?: string;
    staffEmail?: string;
    targetCompanyName?: string;
    targetCompanyId?: string;
    appRole?: string;
    method?: string;
    path?: string;
    statusCode?: number;
    autoLogged?: boolean;
    requestBody?: unknown;
  };
  userEmail?: string;
  userName?: string;
  ipAddress?: string;
  companyId?: string;
  userId?: string;
  createdAt: string;
}

export interface StaffAccessLogsMeta {
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export interface StaffAccessLogsPageResponse {
  data: StaffAccessLog[];
  meta: StaffAccessLogsMeta;
}

export const staffAccessLogsService = {
  async list(params: { page: number; limit: number; staffEmail?: string }): Promise<StaffAccessLogsPageResponse> {
    const search = new URLSearchParams({
      page: String(params.page),
      limit: String(params.limit),
    });
    if (params.staffEmail?.trim()) search.set('staffEmail', params.staffEmail.trim());
    const res = await api.get<{ success: boolean; data: StaffAccessLog[]; meta: StaffAccessLogsMeta }>(
      `/staff-access-logs?${search.toString()}`
    );
    if (!res.data.success) {
      throw new Error('Erro ao buscar logs');
    }
    return { data: res.data.data, meta: res.data.meta };
  },
};
